import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AccountInfo } from './state/init.state';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private apiServerHost: string = environment.apiServerHost;
  constructor(private httpClient: HttpClient) {}

  getUser(userId: number): Observable<AccountInfo> {
    return this.httpClient.get<AccountInfo>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/account-info`,
    );
  }
}
